import { Icon, IconProps } from '../Icon'

export const InfoIcon = ({ color, size }: IconProps) => {
  return (
    <Icon color={color} size={size}>
      info
    </Icon>
  )
}
